import React, { useEffect, useState } from "react";
import Icon from "@ant-design/icons";
import {
  Layout,
  Col,
  Row,
  Menu,
  Dropdown,
  Avatar,
  Divider,
  Typography,
} from "antd";
import {
  MenuOutlined,
  LogoutOutlined,
  LeftCircleFilled,
  RightCircleFilled,
  UserOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import { actions } from "../store/actions";
import { AppState, AuthState, Clinic, User } from "../store";
import { Link } from "react-router-dom";
import paths from "../routes/paths";
const { antdAction } = actions;
interface P {
  authState: AuthState;
  siderControl: () => void;
  logout: () => void;
  opened: boolean;
  currentClinic?: Clinic;
  clinics: Clinic[];
  setSelectedClinic: (v: Clinic) => void;
}
type S = { status: "loading" } | { status: "loaded"; data: User };
function TopBar(props: P) {
  const handleClinicChange = (cId: string) => {
    const s = props.clinics.find((c) => c.id === cId);
    if (s) props.setSelectedClinic(s);
  };



  const menu =
    props.clinics?.length > 1 ? (
      <Menu
        className="menu"
        selectedKeys={props.currentClinic ? [props.currentClinic.id] : []}
        onClick={({ key: cId }: { key: string }) => handleClinicChange(cId)}>
        {props.clinics.map((c) => (
          <Menu.Item key={c.id} icon={<Avatar src={c.logo} />}>
            {c.name}({c.code})
          </Menu.Item>
        ))}
      </Menu>
    ) : (
      <div />
    );
  const profile = props.currentClinic?.logo || "/logo.png";
  return (
    <Layout className="top-bar">
      <Row justify="space-between" align="middle" style={{ height: '100%', width: '100%' }}>
        {/* Left side - Sidebar toggle */}
        <Col flex="none">
          <div style={styles.toggleContainer}>
            {props.opened ? (
              <RightCircleFilled
                style={styles.toggle}
                onClick={() => {
                  props.siderControl();
                }}
              />
            ) : (
              <LeftCircleFilled
                style={styles.toggle}
                onClick={() => {
                  props.siderControl();
                }}
              />
            )}
          </div>
        </Col>
        
        {/* Center - Brand/Company name */}
        <Col flex="auto" style={{ textAlign: 'center' }}>
          <div style={styles.brandContainer}>
            <Typography.Title level={4} style={styles.brandTitle}>
              {props.currentClinic?.company.name}
            </Typography.Title>
            {props.currentClinic?.name && (
              <Link to={paths.clinic} style={styles.clinicLink}>
                {props.currentClinic?.name}
              </Link>
            )}
          </div>
        </Col>
        
        {/* Right side - Clinic selection */}
        <Col flex="none">
          <div style={styles.userContainer}>
            <Dropdown overlay={menu} placement="bottomRight">
              <div style={styles.userDropdown}>
                <Avatar
                  size="default"
                  icon={<UserOutlined />}
                  src={profile}
                  style={styles.userAvatar}
                />
                <span style={styles.userName}>
                  {props.currentClinic?.name || "Select Clinic"}
                </span>
              </div>
            </Dropdown>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}
const mapStateToProps = ({ authState, antdState, clinicState }: AppState) => {
  return {
    authState,
    opened: antdState.openSideToogle,
    currentClinic: clinicState.selected,
    clinics: clinicState.clinics,
  };
};
const mapStateToDispatch = (dispatch: any) => {
  return {
    siderControl: () => {
      dispatch(antdAction.sideOnOff());
    },
    setSelectedClinic: (d: Clinic) =>
      dispatch(actions.clinicAction.setSelected(d)),
    logout: () => dispatch(actions.authAction.loggedOut()),
  };
};
export default connect(mapStateToProps, mapStateToDispatch)(TopBar) as any;
const styles = {
  toggleContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '20px',
    minWidth: '80px',
  },
  toggle: {
    color: "rgba(0, 0, 0, 0.85)",
    fontSize: 22,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    padding: '10px',
    borderRadius: '8px',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
  },
  brandContainer: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    gap: '6px',
    flex: 1,
    padding: '0 20px',
  },
  brandTitle: {
    margin: 0,
    color: 'rgba(0, 0, 0, 0.85)',
    fontWeight: 700,
    textAlign: 'center',
    fontSize: '20px',
  },
  clinicLink: {
    color: 'rgba(0, 0, 0, 0.65)',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500,
    transition: 'color 0.2s ease',
  },
  userContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '20px',
    minWidth: '220px',
    justifyContent: 'flex-end',
  },
  userDropdown: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    padding: '10px 16px',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
    border: '1px solid rgba(0, 0, 0, 0.15)',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    minWidth: '180px',
  },
  userAvatar: {
    border: '2px solid rgba(0, 0, 0, 0.15)',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },
  userName: {
    color: 'rgba(0, 0, 0, 0.85)',
    fontSize: '14px',
    fontWeight: 600,
    maxWidth: '140px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};
